import React, { useState, useEffect, useCallback, useRef } from 'react';
import NexumiLogo from '../common/NexumiLogo';
import SidebarRenderer from '../rbac/SidebarRenderer';
import UserManagementPage from '../../pages/UserManagementPage';
import PerformanceSetupPage from '../../pages/PerformanceSetupPage';
import OffersPage from '../../pages/OffersPage';
import HiresPage from '../../pages/HiresPage';
import RecruitmentHistoryPage from '../../pages/RecruitmentHistoryPage';
import { styled, useTheme, alpha } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Avatar from '@mui/material/Avatar';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import LockResetIcon from '@mui/icons-material/LockReset';
import LogoutIcon from '@mui/icons-material/Logout';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import Chip from '@mui/material/Chip';
import { Route, Switch, Link, useLocation, Redirect } from 'react-router-dom';
import GuardedRoute from '../rbac/guardedRoutes';
import { PERMISSIONS as P } from '../../config/permissions/permissionsConfig';
import RegisterWorker from '../worker/RegisterWorker';
import EditWorker from '../worker/EditWorker';
import WorkerList from '../worker/WorkerList';
import WorkerDetail from '../worker/WorkerDetail';
import TeamManagementPage from '../../pages/TeamManagementPage';
import ContractList from '../contracts/ContractList';
import AddContract from '../contracts/AddContract';
import EditContract from '../contracts/EditContract';
import ContractDetail from '../contracts/ContractDetail';
import AddDepartment from '../department/AddDepartment';
import EditDepartment from '../department/EditDepartment';
import DepartmentList from '../department/DepartmentList';
import AddBranch from '../branch/AddBranch';
import EditBranch from '../branch/EditBranch';
import BranchList from '../branch/BranchList';
import loginService from '../../services/loginService.js';
import SalariesList from './../salaries/SalariesList';
import EditSalary from './../salaries/EditSalary';
import AddSalary from './../salaries/AddSalary';
import MonthSalariesList from '../salaries/MonthSalariesList';
import AddList from '../salaries/AddList';
import AddWorkerContract from '../worker/AddWorkerContract';
import EditWorkerContract from '../worker/EditWorkerContract';
import ArticleIcon from '@mui/icons-material/Article';
import FiscalPoliticsList from '../fiscal-politics/FiscalPoliticsList';
import AddFiscalPolitic from '../fiscal-politics/AddFiscalPolitic';
import EditFiscalPolitic from '../fiscal-politics/EditFiscalPolitics';
import TemplateList from '../contracts-templates/TemplateList';
import AddTemplate from '../contracts-templates/AddTemplate';
import EditTemplate from '../contracts-templates/EditTemplate';
import AddHoliday from '../holidays/AddHoliday';
import EditHoliday from '../holidays/EditHoliday';
import LeaveCalendar from '../holidays/LeaveCalendar';
import Reports from '../report/Reports';
import CreditorMonthlyReport from '../report/CreditorMonthlyReport';
import EmployeeCard from '../report/EmployeeCard';
import EmployeesList from '../report/EmployeesList';
import Analytics from '../report/Analytics';
import EmployeeSummary from '../report/EmployeeSummary';
import CompanyProfile from '../report/CompanyProfile';
import LocalPayrollKS from '../report/LocalPayrollKS';
import ATKReportsKS from '../report/ATKReportsKS';
import ATKRegistrations from '../report/ATKRegistrations';
import MonthlyCostReport from '../report/MonthlyCostReport';
import PresenceReport from '../report/PresenceReport';
import PresenceLogs from '../report/PresenceLogs';
import LeaveBalanceReport from '../report/LeaveBalanceReport';
import HRSpendReport from '../report/HRSpendReport';
import TurnoverReport from '../report/TurnoverReport';
import LeaveReportKS from '../report/LeaveReportKS';
import ProjectActivityReport from '../report/ProjectActivityReport';
import TaskManagementReport from '../report/TaskManagementReport';
import KBPKReport from '../report/KBPKReport';
import InspektoratReport from '../report/InspektoratReport';
import WorkHoursReport from '../report/WorkHoursReport';
import MonthlyWorkHoursReport from '../attendance/MonthlyWorkHoursReport';
import AttendanceReport from '../report/AttendanceReport';
import EmployeeDetailReport from '../report/EmployeeDetailReport';
import WorkerEvaluationReport from '../report/WorkerEvaluationReport';
import OvertimeReport from '../report/OvertimeReport';
import PayrollReport from '../report/PayrollReport';
import ProjectHoursReport from '../report/ProjectHoursReport';
import Company from '../company/Company';
import PaymentsIcon from '@mui/icons-material/Payments';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import GroupsIcon from '@mui/icons-material/Groups';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SchoolIcon from '@mui/icons-material/School';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import TableChartIcon  from '@mui/icons-material/TableChart';
import Overview from './Overview';
import LivePresence, { eventsToPresence } from '../presence/LivePresence';
import RemoteWork          from '../presence/RemoteWork';
import WorkerScanScreen    from '../presence/WorkerScanScreen';
import MyQRScreen          from '../presence/MyQRScreen';
import presenceService from '../../services/presenceService';
import apiService from '../../services/apiServices';
import ChangePassword from '../auth/ChangePassword';
import globals from '../../services/globals';
import EmploymentChanges from '../development/EmploymentChanges';
import TrainingsPage from '../../pages/TrainingsPage';
import WorkerFiles from '../worker-files/WorkerFiles';
import StaffProjectsPage from '../worker/StaffProjectsPage';
import TasksList from '../tasks/TasksList';
import TasksDashboard from '../tasks/TasksDashboard';
import TasksBoard from '../tasks/TasksBoard';
import ClientsList from '../clients/ClientsList';
import ProjectsList from '../projects/ProjectsList';
import ProjectDetail from '../projects/ProjectDetail';
import TicketsList from '../projects/TicketsList';
import ActivitiesList from '../activities/ActivitiesList';
import TimeTracking from '../time-tracking/TimeTracking';
import WorkSchedulesList from '../work-schedules/WorkSchedulesList';
import FTEPlanOretHub from '../../pages/FTEPlanOretHub';
import AssignmentIcon from '@mui/icons-material/Assignment';
import KanbanIcon from '@mui/icons-material/ViewKanban';
import TimerIcon from '@mui/icons-material/Timer';
import InboxIcon from '@mui/icons-material/Inbox';
import config from '../../config/config';
import NotificationBell from '../notifications/NotificationBell';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTour } from '../tour/TourProvider';
import WarningsReport from '../warnings/WarningsReport';
import AddWarning from '../warnings/AddWarning';
import AssetsRegister from '../assets/AssetsRegister';
import AssetDetailPage from '../assets/AssetDetailPage';
import AssetFormPage from '../assets/AssetFormPage';
import AssetHandoverPage from '../assets/AssetHandoverPage';
import MyAssetsPage from '../../pages/MyAssetsPage';
import AuditLog from '../audit/AuditLog';
import CompliancePage from '../compliance/CompliancePage';
import TemplatesPage from '../../pages/TemplatesPage';
import HolidayCalendarPage from '../leave/HolidayCalendarPage';
import ModuleManagementPage from '../../pages/ModuleManagementPage';
import DynamicModulePage from '../../pages/DynamicModulePage';
import SettingsIcon from '@mui/icons-material/Settings';
import UserProfile from '../auth/UserProfile';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import HomeWorkIcon       from '@mui/icons-material/HomeWork';
import PWAInstallBanner from '../common/PWAInstallBanner';
import OfflineBar from '../common/OfflineBar';
import ApplicationsList from '../applications/ApplicationsList';
import ApplicationForm from '../applications/ApplicationForm';
import JobPostingsList from '../applications/JobPostingsList';
import RecruitmentOverview from '../recruitment/RecruitmentOverview';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AttendanceDashboard from '../attendance/AttendanceDashboard';
import MyAttendancePanel from '../attendance/MyAttendancePanel';
import AttendanceSummaryReport from '../attendance/AttendanceSummaryReport';
import ScheduleComplianceReport from '../attendance/ScheduleComplianceReport';
import AttendanceRateReport from '../attendance/AttendanceRateReport';
import AttendanceCorrectionRequests from '../attendance/AttendanceCorrectionRequests';
import ApprovalInbox from '../inbox/ApprovalInbox';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import DateRangeIcon from '@mui/icons-material/DateRange';
import MonthlyIndividualWorkScheduleReport from '../attendance/MonthlyIndividualWorkScheduleReport';
import WorkClock from '../attendance/WorkClock';
import PlaceholderPage from '../../pages/PlaceholderPage';
import ShiftPlanning         from '../company/ShiftPlanning';
import OrgChart              from '../company/OrgChart';
import PayrollAdjustmentsPage from '../../pages/PayrollAdjustmentsPage';
import MyAdjustmentsPage     from '../../pages/MyAdjustmentsPage';
import InterviewsPage        from '../../pages/InterviewsPage';
import HistoryIcon           from '@mui/icons-material/History';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import OnboardingPage        from '../../pages/OnboardingPage';
import OnboardingDetailPage  from '../../pages/OnboardingDetailPage';
import MyTasksPage           from '../../pages/MyTasksPage';
import MyOnboardingPage      from '../../pages/MyOnboardingPage';
import { RegulationsPage, PoliciesPage, ProceduresPage } from '../../pages/PoliciesAndProceduresPage';
import LeavePoliciesPage from '../../pages/LeavePoliciesPage';
import KnowledgeBasePage     from '../../pages/KnowledgeBasePage';
import NotificationsCenterPage from '../../pages/NotificationsCenterPage';
import MyLeavesPage            from '../../pages/MyLeavesPage';
import LeaveAdjustmentsPage   from '../../pages/LeaveAdjustmentsPage';
import CommunicationPage      from '../../pages/CommunicationPage';
import TeamEvaluationsPage    from '../../pages/TeamEvaluationsPage';
import MyLeaveReportPage       from '../../pages/MyLeaveReportPage';
import MyPayslipsPage, { MyPayslipDetailPage, MyPayslipStatsPage } from '../../pages/MyPayslipsPage';
import MyEvaluationPage         from '../../pages/MyEvaluationPage';
import DescriptionIcon        from '@mui/icons-material/Description';
import DocumentsPage         from '../../pages/DocumentsPage';
import EmojiEventsIcon        from '@mui/icons-material/EmojiEvents';
import EventNoteIcon          from '@mui/icons-material/EventNote';
import RecordVoiceOverIcon    from '@mui/icons-material/RecordVoiceOver';
import HowToRegIcon           from '@mui/icons-material/HowToReg';
import CardGiftcardIcon       from '@mui/icons-material/CardGiftcard';
import SavingsIcon            from '@mui/icons-material/Savings';
import ReceiptLongIcon        from '@mui/icons-material/ReceiptLong';
import LibraryBooksIcon       from '@mui/icons-material/LibraryBooks';
import MenuBookIcon           from '@mui/icons-material/MenuBook';
import GavelIcon              from '@mui/icons-material/Gavel';
import PolicyIcon             from '@mui/icons-material/Policy';
import BadgeIcon              from '@mui/icons-material/Badge';
import AccountBalanceIcon     from '@mui/icons-material/AccountBalance';
import BarChartIcon           from '@mui/icons-material/BarChart';
import FolderSpecialIcon      from '@mui/icons-material/FolderSpecial';
import TuneIcon               from '@mui/icons-material/Tune';
import BeachAccessIcon        from '@mui/icons-material/BeachAccess';
import AccountTreeIcon        from '@mui/icons-material/AccountTree';
import SupervisorAccountIcon  from '@mui/icons-material/SupervisorAccount';
import PeopleAltIcon          from '@mui/icons-material/PeopleAlt';
import AssignmentIndIcon      from '@mui/icons-material/AssignmentInd';
import NotificationsIcon      from '@mui/icons-material/Notifications';
import SpeedIcon              from '@mui/icons-material/Speed';
import AutoAwesomeIcon        from '@mui/icons-material/AutoAwesome';
import Badge from '@mui/material/Badge';
import UpdatesModal, { hasSeenCurrentVersion, markVersionSeen, syncSeenFromServer, CURRENT_VERSION } from '../common/UpdatesModal';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../common/LanguageSwitcher';

const drawerWidth = 240; // default sidebar width; fits long labels (e.g. "Menaxhimi i Përdoruesve") on one line
const miniDrawerWidth = 64; // width when collapsed on desktop
// User can drag the right edge to resize the open sidebar between these bounds (Excel-style).
const SIDEBAR_MIN_WIDTH = 200;
const SIDEBAR_MAX_WIDTH = 460;
const SIDEBAR_WIDTH_KEY = 'nexuma:sidebarWidth';

// ── Styled components ────────────────────────────────────────────────────────

const openedMixin = (theme, width = drawerWidth) => ({
  width,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: miniDrawerWidth,
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => !['open', 'isMobile', 'drawerW', 'resizing'].includes(prop),
})(({ theme, open, isMobile, drawerW = drawerWidth, resizing }) => {
  // No transition while the user is dragging the resize handle — the AppBar must
  // track the sidebar edge in real time instead of easing behind it.
  const enter = resizing ? 'none' : theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  });
  const leave = resizing ? 'none' : theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  });
  return {
    zIndex: theme.zIndex.drawer + 1,
    // Theme already gives a frosted-glass appbar
    transition: leave,
    ...(!isMobile && open && {
      marginLeft: drawerW,
      width: `calc(100% - ${drawerW}px)`,
      transition: enter,
    }),
    ...(!isMobile && !open && {
      marginLeft: miniDrawerWidth,
      width: `calc(100% - ${miniDrawerWidth}px)`,
    }),
  };
});

const DesktopDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => !['open', 'drawerW', 'resizing'].includes(prop),
})(({ theme, open, drawerW = drawerWidth, resizing }) => {
  const paperBase = {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderRight: `1px solid ${theme.palette.divider}`,
    borderRadius: 0,
    display: 'flex',
    flexDirection: 'column',
  };
  // While dragging, kill the width easing so the panel follows the cursor 1:1.
  const opened = { ...openedMixin(theme, drawerW), ...(resizing ? { transition: 'none' } : {}) };
  const closed = closedMixin(theme);
  return {
    width: drawerW,
    flexShrink: 0,
    boxSizing: 'border-box',
    ...(open && {
      ...opened,
      '& .MuiDrawer-paper': { ...opened, ...paperBase },
    }),
    ...(!open && {
      ...closed,
      '& .MuiDrawer-paper': { ...closed, ...paperBase },
    }),
  };
});

// ── Nav items ────────────────────────────────────────────────────────────────

const NAV_HR_GROUPS = [
  {
    group: 'Stafi',
    groupIcon: <BadgeIcon />,
    items: [
      { label: 'Punëtorët',           icon: <GroupsIcon />,           to: '/workerlist' },
      { label: 'Staf / Projektet',      icon: <AssignmentIndIcon />,    to: '/staf-projektet' },
      { label: 'Organigrami',          icon: <AccountTreeIcon />,      to: '/org-chart' },
      { label: 'Menaxhimi',            icon: <SupervisorAccountIcon />, to: '/team-management' },
      { label: 'Dosjet',              icon: <FolderOpenIcon />,       to: '/worker-files' },
      { label: 'Kontratat',           icon: <ArticleIcon />,          to: '/contractlist' },
      { label: 'Dokumentet',          icon: <DescriptionIcon />,      to: '/documents' },
      { label: 'Karriera & Kompensimi',           icon: <TrendingUpIcon />,       to: '/advancements' },
      { label: 'Performance',         icon: <EmojiEventsIcon />,      to: '/performance' },
      { label: 'Trajnimet',           icon: <SchoolIcon />,           to: '/trainings' },
      // Onboarding-u është jashtë menyje për tani (shih sidebarConfig.js).
      // Titujt e faqeve mbeten te `getTitle` më poshtë, sepse rrugët hapen
      // ende me URL dhe koka duhet të thotë ku je — jo «Nexuma».
    ],
  },
  {
    group: 'Monitoring',
    groupIcon: <ScheduleIcon />,
    items: [
      // { label: 'Attendance Panel', icon: <DashboardCustomizeIcon />, to: '/attendance' }, // hidden
      { label: 'Check-in / Check-out',  icon: <PendingActionsIcon />,  to: '/presence-live' },
      { label: 'Prezenca ime',          icon: <FactCheckIcon />,       to: '/my-attendance' },
      { label: 'Schedule',              icon: <ScheduleIcon />,        to: '/work-schedules' },
      { label: 'Modelet e Turneve',     icon: <EventNoteIcon />,       to: '/shift-templates' },
      { label: 'Puna Hibride',          icon: <HomeWorkIcon />,        to: '/remote-work' },
      { label: 'Orari Mujor Individual',icon: <DateRangeIcon />,       to: '/home/reports/work-schedule-matrix' },
      { label: 'Plani i Punës',         icon: <FolderOpenIcon />,      to: '/fte-plan' },
      { label: 'Plani i Punës',         icon: <TableChartIcon />,      to: '/oret' },
    ],
  },
  {
    group: 'Pushimet',
    groupIcon: <BeachAccessIcon />,
    items: [
      // "Kërkesat për pushim" (/holidays) and "Miratimi i pushimeve"
      // (/leave-approvals) were retired — the Approval Center (/inbox) lists
      // and approves leave requests off the same API.
      { label: 'Pushimet e mia',        icon: <FactCheckIcon />,        to: '/my-leaves' },
      { label: 'Balanca e pushimeve',   icon: <AssessmentIcon />,       to: '/home/reports/leave-balance' },
      { label: 'Politikat e pushimeve', icon: <GavelIcon />,            to: '/policies' },
      { label: 'Kalendari i pushimeve', icon: <CalendarMonthIcon />,    to: '/leave-calendar' },
    ],
  },
  {
    group: 'Projektet',
    groupIcon: <AccountTreeIcon />,
    items: [
      { label: 'Lista e projekteve', icon: <AccountTreeIcon />, to: '/projects' },
      // ── Pjesët e tjera janë komentuar përkohësisht — mbahet vetëm lista + shtimi i projekteve ──
      // { label: 'Paneli',      icon: <HomeIcon />,        to: '/tasks/dashboard' },
      // { label: 'Bordi',       icon: <KanbanIcon />,      to: '/tasks/board' },
      // { label: 'Detyrat',     icon: <AssignmentIcon />,  to: '/tasks' },
      // { label: 'Bileta WFM',  icon: <InboxIcon />,       to: '/tickets' },
      // { label: 'Klientët',    icon: <BusinessIcon />,    to: '/clients' },
      // { label: 'Aktivitetet', icon: <TimerIcon />,       to: '/activities' },
    ],
  },
  {
    group: 'Rekrutimi',
    groupIcon: <PeopleAltIcon />,
    items: [
      // Në sinkron me sidebarConfig: Trajnimet kaluan te stafi (zhvillimi, jo rekrutimi).
      { label: 'Përmbledhje',  icon: <QueryStatsIcon />,       to: '/recruitment' },
      { label: 'Pozitat',      icon: <WorkOutlineIcon />,      to: '/job-postings' },
      { label: 'Kandidatët',   icon: <PersonSearchIcon />,     to: '/applications' },
      { label: 'Intervistat',  icon: <RecordVoiceOverIcon />,  to: '/interviews' },
      { label: 'Ofertat',      icon: <WorkOutlineIcon />,      to: '/offers' },
      { label: 'Punësimet',    icon: <HowToRegIcon />,         to: '/hires' },
      { label: 'Historiku i rekrutimit', icon: <HistoryIcon />, to: '/recruitment-history' },
    ],
  },
  {
    group: 'Financa',
    groupIcon: <AccountBalanceIcon />,
    items: [
      { label: 'Pagat',         icon: <PaymentsIcon />,      to: '/salarieslist' },
      { label: 'Karriera & Kompensimi',     icon: <TrendingUpIcon />,    to: '/advancements' },
      { label: 'Rregullimet e pagës', icon: <TuneIcon />,    to: '/payroll-adjustments' },
    ],
  },
  {
    group: 'Analiza',
    groupIcon: <BarChartIcon />,
    items: [
      { label: 'Raportet',                icon: <AssessmentIcon />,   to: '/home/reports' },
      { label: 'Raporti Attendance',      icon: <FactCheckIcon />,    to: '/home/reports/attendance-schedule' },
      { label: 'Raporti i Orëve të Punës', icon: <TimerIcon />,        to: '/home/reports/work-hours' },
      { label: 'Vërejtjet',               icon: <WarningAmberIcon />, to: '/warnings' },
      { label: 'Asetet',                  icon: <Inventory2Icon />,   to: '/assets' },
    ],
  },
  {
    group: 'Rregullore & Procedura',
    groupIcon: <FolderSpecialIcon />,
    items: [
      { label: 'Rregulloret',    icon: <GavelIcon />,        to: '/regulations' },
      { label: 'Politikat',      icon: <PolicyIcon />,       to: '/policies' },
      { label: 'Procedurat',     icon: <MenuBookIcon />,     to: '/procedures' },
      { label: 'Qendra e Njohurive', icon: <LibraryBooksIcon />, to: '/knowledge-base' },
    ],
  },
  {
    group: 'Sistemi',
    groupIcon: <TuneIcon />,
    items: [
      { label: 'Njoftimet',   icon: <NotificationsIcon />,  to: '/notifications-center' },
      { label: 'Monitoring',  icon: <SpeedIcon />,          to: '/monitoring' },
      { label: 'Audit Log',   icon: <ManageSearchIcon />,   to: '/audit-log' },
      { label: 'Konfigurimi', icon: <SettingsIcon />,       to: '/company?tab=profili' },
    ],
  },
];

const flatItems = (groups) => groups.flatMap((g) => g.items);

const NAV_TASKS = [
  { label: 'Paneli',            icon: <HomeIcon />,            to: '/tasks/dashboard' },
  { label: 'Bordi',             icon: <KanbanIcon />,          to: '/tasks/board' },
  { label: 'Detyrat',           icon: <AssignmentIcon />,      to: '/tasks' },
  { label: 'Klientët',          icon: <BusinessIcon />,        to: '/clients' },
  { label: 'Bileta WFM',        icon: <InboxIcon />,           to: '/tickets' },
  { label: 'Aktivitetet',       icon: <TimerIcon />,           to: '/activities' },
];

const NAV_ADMIN_GROUPS = NAV_HR_GROUPS;

// Bottom navigation items for mobile (most used pages)
const BOTTOM_NAV_HR = [
  { label: 'Home',       icon: <HomeIcon />,           to: '/' },
  { label: 'Punëtorët', icon: <GroupsIcon />,          to: '/workerlist' },
  { label: 'Pagat',     icon: <PaymentsIcon />,         to: '/salarieslist' },
  { label: 'Pushimet',  icon: <EventAvailableIcon />,   to: '/inbox' },
  { label: 'Menu',      icon: <MenuIcon />,             to: null },
];

const BOTTOM_NAV_WORKER = [
  { label: 'Home',       icon: <HomeIcon />,            to: '/' },
  { label: 'Skano QR',  icon: <QrCodeScannerIcon />,   to: '/scan' },
  { label: 'Monitoring',  icon: <PendingActionsIcon />,   to: '/presence-live' },
  { label: 'Pushimet',  icon: <EventAvailableIcon />,   to: '/my-leaves' },
];

const NAV_WORKER = [
  { label: 'Home',              icon: <HomeIcon />,            to: '/' },
  { label: 'Skano QR',         icon: <QrCodeScannerIcon />,   to: '/scan' },
  { label: 'Prezenca ime',      icon: <FactCheckIcon />,       to: '/my-attendance' },
  { label: 'Prezenca (sot)',    icon: <PendingActionsIcon />,  to: '/presence-live' },
  { label: 'Pushimet',         icon: <EventAvailableIcon />,  to: '/my-leaves' },
];

// ── Nav list content ─────────────────────────────────────────────────────────

function NavList({ pathname, navGroups, navItems: flatFallback, drawerOpen, onClose }) {
  const groups = navGroups || [{ group: null, items: flatFallback || [] }];

  const allPaths = groups.flatMap((g) => g.items.map((it) => it.to.split('?')[0]));

  const isItemActive = React.useCallback((itemTo) => {
    const _to = itemTo.split('?')[0];
    const exactMatchExists = allPaths.some((p) => p !== _to && pathname === p);
    return pathname === _to || (!exactMatchExists && pathname.startsWith(_to + '/'));
  }, [pathname, allPaths]); // eslint-disable-line react-hooks/exhaustive-deps

  const groupHasActive = React.useCallback((g) =>
    g.items.some((it) => isItemActive(it.to))
  , [isItemActive]);

  const [openGroups, setOpenGroups] = React.useState(() =>
    groups.map((g, gi) => groupHasActive(g) || gi === 1)
  );

  React.useEffect(() => {
    setOpenGroups((prev) => groups.map((g, gi) => groupHasActive(g) ? true : prev[gi] ?? (gi === 1)));
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleGroup = (i) =>
    setOpenGroups((prev) => prev.map((v, idx) => (idx === i ? !v : v)));

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.paper',
        overflowY: 'auto',
        overflowX: 'hidden',
        pt: 0.5,
        pb: 2,
        // thin scrollbar
        '&::-webkit-scrollbar': { width: 4 },
        '&::-webkit-scrollbar-track': { bgcolor: 'transparent' },
        '&::-webkit-scrollbar-thumb': { bgcolor: 'divider', borderRadius: 2 },
      }}
    >
      {groups.map((g, gi) => {
        const isOpen = openGroups[gi] ?? false;
        const hasGroup = Boolean(g.group);
        const active = groupHasActive(g);

        return (
          <React.Fragment key={g.group ?? String(gi)}>

            {/* ── Collapsed icon mode: divider ── */}
            {!drawerOpen && gi > 0 && hasGroup && (
              <Divider sx={{ mx: 1.5, my: 0.5, borderColor: 'divider' }} />
            )}

            {/* ── Group header ── */}
            {hasGroup && drawerOpen && (
              <Box
                onClick={() => toggleGroup(gi)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mx: 1,
                  mt: gi === 0 ? 0.75 : 0.25,
                  px: 1,
                  py: 0.6,
                  borderRadius: 1.5,
                  cursor: 'pointer',
                  userSelect: 'none',
                  gap: 1,
                  bgcolor: active && isOpen
                    ? (t) => t.palette.mode === 'dark' ? 'rgba(62,143,163,0.12)' : 'rgba(20,100,120,0.06)'
                    : 'transparent',
                  transition: 'background 0.15s',
                  '&:hover': {
                    bgcolor: (t) => t.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
                  },
                }}
              >
                {/* Group icon */}
                <Box
                  sx={{
                    width: 26,
                    height: 26,
                    borderRadius: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    bgcolor: active
                      ? 'primary.main'
                      : (t) => t.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)',
                    color: active ? '#fff' : 'text.secondary',
                    transition: 'all 0.15s',
                    '& svg': { fontSize: 14 },
                  }}
                >
                  {g.groupIcon || null}
                </Box>

                {/* Group label */}
                <Typography
                  sx={{
                    flex: 1,
                    fontWeight: 600,
                    fontSize: '0.72rem',
                    letterSpacing: '0.04em',
                    textTransform: 'uppercase',
                    color: active ? 'primary.main' : 'text.secondary',
                    lineHeight: 1,
                    transition: 'color 0.15s',
                  }}
                >
                  {g.group}
                </Typography>

                {/* Arrow */}
                <ExpandMoreIcon
                  sx={{
                    fontSize: 15,
                    color: active ? 'primary.main' : 'text.disabled',
                    transition: 'transform 0.2s, color 0.15s',
                    transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                    flexShrink: 0,
                  }}
                />
              </Box>
            )}

            {/* ── Items ── */}
            {drawerOpen ? (
              <Collapse in={hasGroup ? isOpen : true} timeout={180} unmountOnExit>
                <List
                  disablePadding
                  sx={{
                    mx: 1,
                    mt: 0.25,
                    mb: 0.5,
                    pl: 1.5,
                    borderLeft: (t) => `2px solid ${
                      active
                        ? t.palette.mode === 'dark' ? 'rgba(62,143,163,0.4)' : 'rgba(20,100,120,0.18)'
                        : t.palette.divider
                    }`,
                    transition: 'border-color 0.2s',
                  }}
                >
                  {g.items.map((item) => {
                    const itemActive = isItemActive(item.to);
                    const linkProps = item.external
                      ? { component: 'a', href: `/#${item.to}`, onClick: onClose }
                      : { component: Link, to: item.to, onClick: onClose };
                    return (
                      <ListItem key={item.to} disablePadding>
                        <ListItemButton
                          {...linkProps}
                          selected={itemActive && !item.external}
                          sx={{
                            py: 0.45,
                            px: 0.75,
                            borderRadius: 1,
                            minHeight: 30,
                            '&.Mui-selected': {
                              bgcolor: 'primary.main',
                              color: '#fff',
                              '&:hover': { bgcolor: 'primary.dark' },
                              '& .MuiListItemIcon-root': { color: '#fff' },
                            },
                            '&:hover:not(.Mui-selected)': {
                              bgcolor: (t) => t.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 26,
                              color: itemActive ? '#fff' : 'text.disabled',
                              '& svg': { fontSize: 14 },
                            }}
                          >
                            {item.icon}
                          </ListItemIcon>
                          <ListItemText
                            primary={item.label}
                            primaryTypographyProps={{
                              sx: {
                                fontWeight: itemActive ? 600 : 450,
                                fontSize: '0.78rem',
                                letterSpacing: '-0.01em',
                                lineHeight: 1.3,
                                color: itemActive ? '#fff' : 'text.primary',
                              },
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
              </Collapse>
            ) : (
              // ── Collapsed icon-only mode ──
              <List disablePadding sx={{ px: 0.5 }}>
                {g.items.map((item) => {
                  const itemActive = isItemActive(item.to);
                  const linkProps = item.external
                    ? { component: 'a', href: `/#${item.to}`, onClick: onClose }
                    : { component: Link, to: item.to, onClick: onClose };
                  const btn = (
                    <ListItem key={item.to} disablePadding>
                      <ListItemButton
                        {...linkProps}
                        selected={itemActive && !item.external}
                        sx={{
                          py: 0.5,
                          borderRadius: 1,
                          minHeight: 34,
                          justifyContent: 'center',
                          '&.Mui-selected': {
                            bgcolor: 'primary.main',
                            color: '#fff',
                            '&:hover': { bgcolor: 'primary.dark' },
                            '& .MuiListItemIcon-root': { color: '#fff' },
                          },
                          '&:hover': { bgcolor: 'rgba(62,143,163,0.07)' },
                        }}
                      >
                        <ListItemIcon sx={{ minWidth: 0, '& svg': { fontSize: 18 } }}>
                          {item.icon}
                        </ListItemIcon>
                      </ListItemButton>
                    </ListItem>
                  );
                  return (
                    <Tooltip key={item.to} title={item.label} placement="right" arrow>
                      <span>{btn}</span>
                    </Tooltip>
                  );
                })}
              </List>
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
}

// ── Main component ───────────────────────────────────────────────────────────

export default function Dashboard() {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));

  // Mobile: controls temporary drawer
  const [mobileOpen, setMobileOpen] = useState(false);
  // Desktop: controls mini ↔ full drawer
  const [desktopOpen, setDesktopOpen] = useState(!isTablet);

  // Desktop: draggable sidebar width (Excel-style column resize), persisted per browser.
  const clampSidebar = (w) => Math.min(SIDEBAR_MAX_WIDTH, Math.max(SIDEBAR_MIN_WIDTH, w));
  const [sidebarWidth, setSidebarWidth] = useState(() => {
    const saved = parseInt(localStorage.getItem(SIDEBAR_WIDTH_KEY), 10);
    return Number.isFinite(saved) ? clampSidebar(saved) : drawerWidth;
  });
  const [resizing, setResizing] = useState(false);
  const resizeCleanup = useRef(null);

  useEffect(() => {
    try { localStorage.setItem(SIDEBAR_WIDTH_KEY, String(sidebarWidth)); } catch (_) {}
  }, [sidebarWidth]);

  const startSidebarResize = useCallback((e) => {
    e.preventDefault();
    setResizing(true);
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    const onMove = (ev) => {
      const x = ev.touches ? ev.touches[0].clientX : ev.clientX;
      setSidebarWidth(clampSidebar(x));
    };
    const onUp = () => {
      setResizing(false);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      document.removeEventListener('touchmove', onMove);
      document.removeEventListener('touchend', onUp);
      resizeCleanup.current = null;
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('touchend', onUp);
    resizeCleanup.current = onUp;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Safety: tear down listeners if the component unmounts mid-drag.
  useEffect(() => () => { if (resizeCleanup.current) resizeCleanup.current(); }, []);

  const [anchorEl, setAnchorEl] = useState(null);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [sidePresence, setSidePresence] = useState({ present: 0, absent: 0, total: 0 });
  const [updatesOpen, setUpdatesOpen] = useState(false);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [qrOpen, setQrOpen] = useState(false);

  const currentUser = globals().getLogedInUser();
  const roleNames = (currentUser?.data?.roles || currentUser?.roles || [])
    .map((r) => (r?.name || r?.role_name || r || '').toString().toLowerCase().trim())
    .filter(Boolean);
  const hasAdminRole = roleNames.some((r) => r === 'admin' || r === 'menaxher' || r === 'manager');
  const isWorkerOnly = roleNames.length > 0 && !hasAdminRole;

  const _userId = currentUser?.data?.id || currentUser?.id;
  const _workerId = currentUser?.data?.worker_id || currentUser?.worker_id || '';
  const _workerName = [currentUser?.data?.firstname, currentUser?.data?.lastname].filter(Boolean).join(' ')
    || currentUser?.data?.username || '';
  const [updatesUnseen, setUpdatesUnseen] = useState(() => !hasSeenCurrentVersion(_userId));

  // Ngarko foton e profilit
  useEffect(() => {
    if (!_userId) return;
    apiService().getById('users', _userId)
      .then(r => { if (r?.success && r?.data?.profile_photo) setProfilePhoto(r.data.profile_photo); })
      .catch(() => {});
  }, [_userId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Ngarko logon e kompanisë
  useEffect(() => {
    apiService().get('settings')
      .then(r => { const logo = r?.data?.[0]?.Logo; if (logo) setCompanyLogo(logo); })
      .catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-open updates modal ONCE per version, per user. We persist the "seen"
  // flag the moment it auto-opens (not only on close), so it never re-appears on
  // subsequent logins/refreshes regardless of how the user dismisses it.
  useEffect(() => {
    if (!_userId) return undefined;
    if (hasSeenCurrentVersion(_userId)) return undefined;

    // Kujtesa lokale thotë «e pa parë», por ajo i takon këtij shfletuesi. Para
    // se të hapim gjë, pyetet serveri: ndoshta personi e ka parë nga kompjuteri
    // tjetër, ose pas një pastrimi cache-je. Pa përgjigje, vendos kujtesa lokale.
    let cancelled = false;
    let timer = null;
    syncSeenFromServer(_userId).then((seenOnServer) => {
      if (cancelled || seenOnServer === true) return;
      timer = setTimeout(() => {
        if (cancelled) return;
        setUpdatesOpen(true);
        markVersionSeen(_userId);
      }, 600);
    });
    return () => { cancelled = true; if (timer) clearTimeout(timer); };
  }, [_userId]); // eslint-disable-line react-hooks/exhaustive-deps
  const location = useLocation();

  const adminNavGroups = NAV_ADMIN_GROUPS;
  const workerNavItems = NAV_WORKER;

  const navGroups  = isWorkerOnly ? null : adminNavGroups;
  const navItems   = isWorkerOnly ? workerNavItems : flatItems(adminNavGroups);
  const companyLabel = getCompanyLabel(currentUser);

  const handleMenu    = (e) => setAnchorEl(e.currentTarget);
  const handleClose   = () => setAnchorEl(null);

  const handleChangePassword = () => { setAnchorEl(null); setChangePasswordOpen(true); };
  const handleLogout = () => { setAnchorEl(null); setLogoutDialogOpen(true); };

  const handleToggleMobile  = () => setMobileOpen((p) => !p);
  const handleCloseMobile   = () => setMobileOpen(false);
  const handleToggleDesktop = () => setDesktopOpen((p) => !p);

  const bottomNavItems = isWorkerOnly ? BOTTOM_NAV_WORKER : BOTTOM_NAV_HR;
  // Find active bottom nav index
  const bottomNavValue = bottomNavItems.findIndex((item) => {
    if (!item.to) return false;
    if (item.to === '/') return location.pathname === '/';
    return location.pathname.startsWith(item.to);
  });

  // effective open state for rendering
  const drawerOpen = isMobile ? true : desktopOpen;

  // App tour — keep the desktop drawer open while the guided tour is running so
  // the sidebar section anchors are always visible/measurable.
  const tour = useTour();
  useEffect(() => {
    if (tour.isActive && !isMobile) setDesktopOpen(true);
  }, [tour.isActive, isMobile]);

  // Fetch today's presence for sidebar widget (HR only, refresh every 2 min)
  useEffect(() => {
    if (isWorkerOnly) return;
    let mounted = true;
    async function fetchSidePresence() {
      try {
        const [wRes, events] = await Promise.all([
          apiService().get('workers'),
          presenceService().getDay(),
        ]);
        if (!mounted) return;
        const presMap = eventsToPresence(events);
        const present = Object.values(presMap).filter(e => e.checkIn && !e.checkOut).length;
        const total = (wRes?.data || []).length;
        setSidePresence({ present, absent: Math.max(0, total - present), total });
      } catch (_) {}
    }
    fetchSidePresence();
    const timer = setInterval(fetchSidePresence, 2 * 60 * 1000);
    return () => { mounted = false; clearInterval(timer); };
  }, [isWorkerOnly]);

  const drawerContent = (
    <>
      {!isMobile && (
        <DrawerHeader sx={{ flexShrink: 0, borderBottom: `1px solid ${theme.palette.divider}`, justifyContent: desktopOpen ? 'space-between' : 'center', px: desktopOpen ? 1.5 : 0, gap: 1 }}>
          {desktopOpen && (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, minWidth: 0, py: 0.5, '& img': { maxWidth: '100%', objectFit: 'contain' } }}>
              {companyLogo
                ? <Box component="img" src={companyLogo} alt="logo" sx={{ height: 36, width: 'auto', maxWidth: '100%', objectFit: 'contain', borderRadius: 1 }} />
                : <NexumiLogo height={28} variant="dark" />}
            </Box>
          )}
          <IconButton onClick={handleToggleDesktop} size="small" sx={{ flexShrink: 0 }}>
            <ChevronLeftIcon sx={{ transform: desktopOpen ? 'none' : 'rotate(180deg)', transition: 'transform .3s' }} />
          </IconButton>
        </DrawerHeader>
      )}
      <SidebarRenderer
        drawerOpen={drawerOpen}
        onClose={isMobile ? handleCloseMobile : undefined}
      />
    </>
  );

  return (
    <Box sx={{ display: 'flex', height: '100vh', '@supports (height: 100dvh)': { height: '100dvh' }, overflow: 'hidden' }}>
      <CssBaseline />

      {/* ── AppBar ── */}
      <AppBar position="fixed" open={desktopOpen} isMobile={isMobile} drawerW={sidebarWidth} resizing={resizing}>
        <Toolbar sx={{ gap: { xs: 0.5, sm: 1 } }}>
          <IconButton
            aria-label="open drawer"
            onClick={isMobile ? handleToggleMobile : handleToggleDesktop}
            edge="start"
            sx={{ mr: { xs: 0.5, sm: 1 } }}
          >
            <MenuIcon sx={{ fontSize: 20 }} />
          </IconButton>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexGrow: 1, minWidth: 0 }}>
            <Typography
              variant="h6"
              noWrap
              sx={{
                fontWeight: 600,
                fontSize: { xs: '0.9375rem', sm: '1rem' },
                letterSpacing: '-0.015em',
                color: 'text.primary',
              }}
            >
              {tPageTitle(location.pathname, navItems, t)}
            </Typography>
            {companyLabel && !isMobile && (
              <Chip
                size="small"
                label={companyLabel}
                sx={{
                  fontWeight: 600,
                  bgcolor: 'grey.100',
                  color: 'text.secondary',
                  textTransform: 'none',
                  letterSpacing: 0,
                  fontSize: '0.6875rem',
                  border: 0,
                  height: 22,
                }}
              />
            )}
          </Box>

          {/* Work clock — start / pause / end */}
          {_workerId && (
            <Box data-tour="work-clock" sx={{ display: 'inline-flex', alignItems: 'center' }}>
              <WorkClock workerId={_workerId} />
            </Box>
          )}

          {/* Action icons — consistent 4px gap, no extra mr */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Tooltip title={t('menu.updates')} placement="bottom" arrow>
              <IconButton
                aria-label="updates"
                onClick={() => { setUpdatesOpen(true); setUpdatesUnseen(false); }}
              >
                <Badge variant="dot" color="error" invisible={!updatesUnseen}>
                  <AutoAwesomeIcon sx={{ fontSize: 20 }} />
                </Badge>
              </IconButton>
            </Tooltip>

            {_workerId && (
              <Tooltip title={t('menu.myQr', 'QR Code')} placement="bottom" arrow>
                <IconButton aria-label="my-qr" onClick={() => setQrOpen(true)}>
                  <QrCode2Icon sx={{ fontSize: 20 }} />
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title={t('tour.help', 'Tur i aplikacionit')} placement="bottom" arrow>
              <IconButton
                data-tour="tour-help" aria-label="app-tour" onClick={() => tour.start('full')}
                sx={{
                  color: 'primary.main', border: '1px solid', borderColor: (th) => alpha(th.palette.primary.main, 0.4),
                  bgcolor: (th) => alpha(th.palette.primary.main, 0.08),
                  '&:hover': { bgcolor: (th) => alpha(th.palette.primary.main, 0.18), borderColor: 'primary.main' },
                }}
              >
                <HelpOutlineIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>

            {/* Chat moved to the floating panel bottom-right — one entry point,
                not three. The bell here duplicated its unread count. */}

            <Box data-tour="notifications" sx={{ display: 'inline-flex', alignItems: 'center' }}>
              <NotificationBell />
            </Box>

            {location.pathname !== '/' && (
              <Tooltip title={t('menu.home', 'Home')} placement="bottom" arrow>
                <IconButton component={Link} to="/" aria-label="home">
                  <HomeIcon sx={{ fontSize: 20 }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>

          {/* Divider before profile */}
          {!isMobile && (
            <Box sx={{ width: '1px', height: 24, bgcolor: 'divider', mx: 1 }} />
          )}

          {/* Profile pill */}
          <Box
            onClick={handleMenu}
            data-tour="profile"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              cursor: 'pointer',
              pl: { xs: 0.5, sm: 0.75 },
              pr: { xs: 0.5, sm: 1.25 },
              py: 0.5,
              borderRadius: 999,
              border: '1px solid',
              borderColor: 'transparent',
              transition: 'background-color 0.15s ease, border-color 0.15s ease',
              '&:hover': { bgcolor: 'grey.50', borderColor: 'divider' },
            }}
          >
            {profilePhoto
              ? <Avatar src={profilePhoto} sx={{ width: 30, height: 30 }} />
              : <Avatar sx={{ width: 30, height: 30, bgcolor: 'primary.soft', color: 'primary.dark' }}>
                  {[currentUser?.data?.firstname?.[0], currentUser?.data?.lastname?.[0]].filter(Boolean).join('').toUpperCase() || <AccountCircle sx={{ fontSize: 22 }} />}
                </Avatar>
            }
            {!isMobile && (
              <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0, lineHeight: 1.2, maxWidth: 140 }}>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, fontSize: '0.8125rem', color: 'text.primary', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                >
                  {[currentUser?.data?.firstname, currentUser?.data?.lastname].filter(Boolean).join(' ') || currentUser?.data?.username || 'User'}
                </Typography>
                {roleNames[0] && (
                  <Typography
                    variant="caption"
                    sx={{ color: 'text.secondary', fontSize: '0.6875rem', fontWeight: 500, textTransform: 'capitalize', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                  >
                    {roleNames[0]}
                  </Typography>
                )}
              </Box>
            )}
          </Box>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{ sx: { mt: 1.5, minWidth: 200, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 2 } }}
          >
            <MenuItem onClick={handleClose} sx={{ gap: 1.5, py: 1.5, px: 2 }}>
              <Link to="/profile" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none', color: 'inherit', width: '100%' }}>
                <PersonIcon fontSize="small" color="action" />
                <Typography variant="body2">{t('menu.profile')}</Typography>
              </Link>
            </MenuItem>
            <MenuItem onClick={handleClose} sx={{ gap: 1.5, py: 1.5 }}>
              <Link to="/company" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none', color: 'inherit', width: '100%' }}>
                <BusinessIcon fontSize="small" color="action" />
                <Typography variant="body2">{t('menu.company')}</Typography>
              </Link>
            </MenuItem>
            <MenuItem onClick={handleClose} sx={{ gap: 1.5, py: 1.5 }}>
              <Link to="/audit-log" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none', color: 'inherit', width: '100%' }}>
                <ManageSearchIcon fontSize="small" color="action" />
                <Typography variant="body2">{t('menu.auditLog')}</Typography>
              </Link>
            </MenuItem>
            <Divider sx={{ my: 0.5 }} />
            <LanguageSwitcher onClose={handleClose} />
            <Divider sx={{ my: 0.5 }} />
            <MenuItem onClick={handleChangePassword} sx={{ gap: 1.5, py: 1.5 }}>
              <LockResetIcon fontSize="small" color="primary" />
              <Typography variant="body2">{t('menu.changePassword')}</Typography>
            </MenuItem>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem onClick={handleLogout} sx={{ gap: 1.5, py: 1.5, color: '#dc2626', '&:hover': { bgcolor: '#fef2f2' } }}>
              <LogoutIcon fontSize="small" sx={{ color: '#dc2626' }} />
              <Typography variant="body2" sx={{ color: '#dc2626', fontWeight: 600 }}>{t('menu.logout')}</Typography>
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* ── My QR dialog — opens from the header QR icon ── */}
      <Dialog
        open={qrOpen}
        onClose={() => setQrOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
      >
        <DialogContent sx={{ p: 0 }}>
          {qrOpen && <MyQRScreen workerId={_workerId} workerName={_workerName} />}
        </DialogContent>
      </Dialog>

      {/* ── Drawer — Mobile (temporary, overlay) ── */}
      {isMobile && (
        <MuiDrawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleCloseMobile}
          ModalProps={{ keepMounted: true }}
          sx={{
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              maxWidth: 'calc(100vw - 32px)',
              boxSizing: 'border-box',
              bgcolor: 'background.paper',
              borderRight: `1px solid ${theme.palette.divider}`,
              display: 'flex',
              flexDirection: 'column',
            },
          }}
        >
          {/* Logo strip in mobile drawer header */}
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flexShrink: 0, gap: 1, px: 2, py: 1.5, '& img': { maxWidth: '100%', objectFit: 'contain' }, borderBottom: `1px solid ${theme.palette.divider}` }}>
            {companyLogo
              ? <Box component="img" src={companyLogo} alt="logo" sx={{ height: 36, width: 'auto', maxWidth: '100%', objectFit: 'contain', borderRadius: 1 }} />
              : <NexumiLogo height={28} variant="dark" />}
            {companyLabel && (
              <Chip size="small" label={companyLabel} sx={{ textTransform: 'uppercase', fontWeight: 600, fontSize: '0.68rem', maxWidth: '100%', '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' }, border: '1px solid rgba(15,23,42,0.07)', bgcolor: 'rgba(15,23,42,0.04)', color: 'text.secondary' }} />
            )}
          </Box>
          {drawerContent}
        </MuiDrawer>
      )}

      {/* ── Drawer — Desktop (permanent mini ↔ full, drag-resizable) ── */}
      {!isMobile && (
        <DesktopDrawer variant="permanent" open={desktopOpen} drawerW={sidebarWidth} resizing={resizing}>
          {drawerContent}
        </DesktopDrawer>
      )}

      {/* ── Resize handle — drag to widen/narrow the sidebar (Excel-style); double-click to reset ── */}
      {!isMobile && desktopOpen && (
        <Box
          role="separator"
          aria-orientation="vertical"
          aria-label="Ndrysho gjerësinë e menusë anësore"
          onMouseDown={startSidebarResize}
          onTouchStart={startSidebarResize}
          onDoubleClick={() => setSidebarWidth(drawerWidth)}
          sx={{
            position: 'fixed',
            top: 0,
            left: sidebarWidth - 3,
            width: 6,
            height: '100vh',
            cursor: 'col-resize',
            zIndex: (t) => t.zIndex.drawer + 2,
            transition: resizing ? 'none' : 'left .0s, background-color .15s',
            // Thin accent line centred in the hit area; brightens on hover / active drag.
            '&::after': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 2,
              width: 2,
              height: '100%',
              bgcolor: resizing ? alpha(theme.palette.primary.main, 0.6) : 'transparent',
              transition: 'background-color .15s',
            },
            '&:hover::after': { bgcolor: alpha(theme.palette.primary.main, 0.5) },
          }}
        />
      )}

      {/* ── Main content ── */}
      <Box
        component="main"
        data-tour="content"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflowY: ['/', '/worker-files'].includes(location.pathname) ? 'hidden' : 'auto',
          overflowX: ['/home/reports/work-schedule-matrix', '/oret'].includes(location.pathname) ? 'auto' : 'hidden',
          p: ['/', '/worker-files', '/home/reports/work-schedule-matrix', '/oret'].includes(location.pathname) ? 0 : { xs: 2, sm: 2.5, md: 3.5 },
          pb: ['/', '/worker-files', '/oret'].includes(location.pathname) ? { xs: '68px', sm: '68px', md: 0 } : { xs: '76px', sm: '76px', md: 3.5 },
          width: {
            xs: '100%',
            md: `calc(100% - ${desktopOpen ? sidebarWidth : miniDrawerWidth}px)`,
          },
          transition: resizing ? 'none' : undefined,
        }}
      >
        <DrawerHeader />
        {/* Titulli i faqes jeton te AppBar-i, i cili rri gjithmonë i dukshëm.
            Këtu më parë injektohej i njëjti `tPageTitle(...)` si te AppBar-i —
            fjalë për fjalë e njëjta thirrje, dy herë, 40px larg njëra-tjetrës.
            Faqet që duan kokë me nëntitull dhe veprime e sjellin vetë; ky bllok
            s'kishte as njërën as tjetrën, ndaj u hoq bashkë me listën e gjatë të
            përjashtimeve që i duhej. */}

        {isWorkerOnly ? (
          // Employee-only Switch — every route here is already safe for an
          // Employee (the isWorkerOnly check above acts as the role guard),
          // so we use plain <Route> to avoid auto-derived admin requirements
          // from sidebarConfig blocking pages an employee legitimately needs
          // (e.g. /holidays for submitting their own request).
          <Switch>
            <Route exact path="/"><Overview /></Route>
            <Route path="/scan"><WorkerScanScreen /></Route>
            <Route path="/my-attendance"><MyAttendancePanel /></Route>
            <Route path="/inbox"><ApprovalInbox /></Route>
            <Route path="/attendance-corrections"><AttendanceCorrectionRequests /></Route>
            <Route path="/presence-live"><LivePresence /></Route>
            <Route path="/holidays/addholiday"><AddHoliday /></Route>
            <Route path="/holidays/editholiday/:id"><EditHoliday /></Route>
            <Route path="/holidays/calendar"><LeaveCalendar /></Route>
            {/* Retired module — an employee's leave list lives in /my-leaves. */}
            <Route path="/holidays"><Redirect to="/my-leaves" /></Route>
            <Route path="/my-leaves"><MyLeavesPage /></Route>
            <Route path="/my-leave-report"><MyLeaveReportPage /></Route>
            <Route path="/leave-calendar"><HolidayCalendarPage /></Route>
            <Route path="/home/reports/presence"><PresenceReport /></Route>
            <Route path="/home/reports/leave-balance"><LeaveBalanceReport /></Route>
            <Route path="/home/reports/work-schedule-matrix"><MonthlyIndividualWorkScheduleReport /></Route>
            <Route path="/home/reports/employee-detail"><EmployeeDetailReport /></Route>
            <Route path="/home/reports/employee-card/:id" component={EmployeeCard} />
            <Route path="/home/reports"><Reports /></Route>
            <Route path="/time-tracking"><TimeTracking /></Route>
            <Route path="/my-payslips/stats/:year"><MyPayslipStatsPage /></Route>
            <Route path="/my-payslips/:year/:month"><MyPayslipDetailPage /></Route>
            <Route path="/my-payslips"><MyPayslipsPage /></Route>
            <Route path="/my-adjustments"><MyAdjustmentsPage /></Route>
            <Route path="/profile"><UserProfile /></Route>
            <Redirect to="/" />
          </Switch>
        ) : (
          <Switch>
            <GuardedRoute exact path="/"><Overview /></GuardedRoute>
            <GuardedRoute exact path="/directory"><Redirect to="/workerlist" /></GuardedRoute>
            <GuardedRoute path="/scan"><WorkerScanScreen /></GuardedRoute>
            <GuardedRoute path="/presence-live"><LivePresence /></GuardedRoute>
            <GuardedRoute path="/attendance"><AttendanceDashboard /></GuardedRoute>
            <GuardedRoute path="/my-attendance"><MyAttendancePanel /></GuardedRoute>
            <GuardedRoute path="/inbox"><ApprovalInbox /></GuardedRoute>
            <GuardedRoute path="/attendance-corrections"><AttendanceCorrectionRequests /></GuardedRoute>
            <GuardedRoute path="/remote-work"><RemoteWork /></GuardedRoute>
            <GuardedRoute path="/advancements"><EmploymentChanges /></GuardedRoute>
            <GuardedRoute path="/trainings"><TrainingsPage /></GuardedRoute>
            <GuardedRoute exact path="/tasks/dashboard"><TasksDashboard /></GuardedRoute>
            <GuardedRoute path="/tasks/board"><TasksBoard /></GuardedRoute>
            <GuardedRoute path="/tasks"><TasksList /></GuardedRoute>
            <GuardedRoute path="/clients"><ClientsList /></GuardedRoute>
            <GuardedRoute path="/staf-projektet"><StaffProjectsPage /></GuardedRoute>
            <GuardedRoute exact path="/projects"><ProjectsList /></GuardedRoute>
            <GuardedRoute path="/projects/:id"
              requiresAny={['projects.view.own', 'projects.view.team', 'projects.view.company']}>
              <ProjectDetail />
            </GuardedRoute>
            <GuardedRoute path="/tickets"><TicketsList /></GuardedRoute>
            <GuardedRoute path="/activities"><ActivitiesList /></GuardedRoute>
            <GuardedRoute path="/time-tracking"><TimeTracking /></GuardedRoute>
            <GuardedRoute path="/work-schedules"><WorkSchedulesList /></GuardedRoute>
            <GuardedRoute path="/fte-plan/:projectId?"><FTEPlanOretHub /></GuardedRoute>
            <GuardedRoute path="/oret"><FTEPlanOretHub /></GuardedRoute>
            <GuardedRoute path="/worker-files"><WorkerFiles /></GuardedRoute>
            <GuardedRoute path="/workerlist/addworkercontract/:id"><AddWorkerContract /></GuardedRoute>
            <GuardedRoute path="/workerlist/editworkercontract/:id/:con"><EditWorkerContract /></GuardedRoute>
            <GuardedRoute path="/workerlist/editworkercontract/:id"><EditWorkerContract /></GuardedRoute>
            <GuardedRoute path="/workerlist/register"><RegisterWorker /></GuardedRoute>
            {/* Krijimi i punëtorit ka një formë të vetme: `RegisterWorker`.
                `AddWorker` ishte varianti i vjetër me 21 fusha më pak dhe pa
                kontratë — të dyja rrugët e vjetra bien këtu, që një lidhje e
                ruajtur apo një faqe e vjetër të mos çojë te forma e cunguar.
                Skedari `AddWorker.js` mbetet në vend (e lexojnë dy teste si
                burim), thjesht nuk ka më rrugë drejt tij. */}
            <GuardedRoute path="/workerlist/addworker"><Redirect to="/workerlist/register" /></GuardedRoute>
            <GuardedRoute path="/workerlist/quick-add"><Redirect to="/workerlist/register" /></GuardedRoute>
            <GuardedRoute path="/workerlist/editworker/:id"><EditWorker /></GuardedRoute>
            <GuardedRoute path="/workerlist/worker/:id"><WorkerDetail /></GuardedRoute>
            <GuardedRoute path="/team-management"><TeamManagementPage /></GuardedRoute>
            <GuardedRoute path="/workerlist" component={WorkerList} />
            <GuardedRoute path="/contractlist/addcontract"><AddContract /></GuardedRoute>
            <GuardedRoute path="/contractlist/editcontract/:id"><EditContract /></GuardedRoute>
            <GuardedRoute path="/contractlist/contract/:id"><ContractDetail /></GuardedRoute>
            <GuardedRoute path="/contractlist" component={ContractList} />
            <GuardedRoute path="/salarieslist/addsalary"><AddSalary /></GuardedRoute>
            <GuardedRoute path="/salarieslist/addlist"><AddList /></GuardedRoute>
            <GuardedRoute path="/salarieslist/editlist/:id"><AddList /></GuardedRoute>
            <GuardedRoute path="/salarieslist/editsalary/:id"><EditSalary /></GuardedRoute>
            <GuardedRoute path="/salarieslist/monthlist/:year/:month"><MonthSalariesList /></GuardedRoute>
            <GuardedRoute path="/salarieslist" component={SalariesList} />
            <GuardedRoute path="/departmentlist/adddepartment"><AddDepartment /></GuardedRoute>
            <GuardedRoute path="/departmentlist/editdepartment/:id"><EditDepartment /></GuardedRoute>
            <GuardedRoute path="/departmentlist" component={DepartmentList} />
            <GuardedRoute path="/branchlist/addbranch"><AddBranch /></GuardedRoute>
            <GuardedRoute path="/branchlist/editbranch/:id"><EditBranch /></GuardedRoute>
            <GuardedRoute path="/branchlist" component={BranchList} />
            <GuardedRoute path="/fiscal/addfiscal"><AddFiscalPolitic /></GuardedRoute>
            <GuardedRoute path="/fiscal/editfiscal/:id"><EditFiscalPolitic /></GuardedRoute>
            <GuardedRoute path="/fiscal" component={FiscalPoliticsList} />
            <GuardedRoute path="/contracts-templates/addtemplate"><AddTemplate /></GuardedRoute>
            <GuardedRoute path="/contracts-templates/edittemplate/:id"><EditTemplate /></GuardedRoute>
            <GuardedRoute path="/contracts-templates" component={TemplateList} />
            <GuardedRoute path="/home/reports/creditor-monthly" component={CreditorMonthlyReport} />
            <GuardedRoute path="/home/reports/employee-card/:id" component={EmployeeCard} />
            <GuardedRoute path="/home/reports/employees-cards" component={EmployeesList} />
            <GuardedRoute path="/home/reports/analytics"><Analytics /></GuardedRoute>
            <GuardedRoute path="/home/reports/employee-summary"><EmployeeSummary /></GuardedRoute>
            <GuardedRoute path="/home/reports/company-profile"><CompanyProfile /></GuardedRoute>
            <GuardedRoute path="/home/reports/local-payroll-ks"><LocalPayrollKS /></GuardedRoute>
            <GuardedRoute path="/home/reports/atk-tm"><ATKReportsKS /></GuardedRoute>
            <GuardedRoute path="/home/reports/atk-registrations"><ATKRegistrations /></GuardedRoute>
            <GuardedRoute path="/home/reports/monthly-costs"><MonthlyCostReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/presence"><PresenceReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/presence-logs"><PresenceLogs /></GuardedRoute>
            <GuardedRoute path="/home/reports/leave-balance"><LeaveBalanceReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/leave-ks"><LeaveReportKS /></GuardedRoute>
            <GuardedRoute path="/home/reports/hr-spend"><HRSpendReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/turnover"><TurnoverReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/task-management"><TaskManagementReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/project-activity"><ProjectActivityReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/kbpk"><KBPKReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/inspektorat"><InspektoratReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/work-schedule-matrix"><MonthlyIndividualWorkScheduleReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/work-hours"><MonthlyWorkHoursReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/attendance-schedule"><AttendanceSummaryReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/schedule-compliance-summary"><ScheduleComplianceReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/attendance-rate"><AttendanceRateReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/attendance"><AttendanceReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/employee-detail"><EmployeeDetailReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/worker-evaluation"><WorkerEvaluationReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/overtime"><OvertimeReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/payroll"><PayrollReport /></GuardedRoute>
            <GuardedRoute path="/home/reports/project-hours"><ProjectHoursReport /></GuardedRoute>
            <GuardedRoute path="/home/reports" component={Reports} />
            <GuardedRoute path="/my-evaluation"><MyEvaluationPage /></GuardedRoute>
            <GuardedRoute path="/team-evaluations"><TeamEvaluationsPage /></GuardedRoute>
            <GuardedRoute path="/performance-setup"><PerformanceSetupPage /></GuardedRoute>
            <GuardedRoute path="/performance"><WorkerEvaluationReport /></GuardedRoute>
            <GuardedRoute path="/shift-templates"><ShiftPlanning /></GuardedRoute>
            <GuardedRoute path="/org-chart"><OrgChart /></GuardedRoute>
            <GuardedRoute path="/interviews"><InterviewsPage /></GuardedRoute>
            <GuardedRoute path="/offers"><OffersPage /></GuardedRoute>
            <GuardedRoute path="/hires"><HiresPage /></GuardedRoute>
            <GuardedRoute path="/recruitment-history"><RecruitmentHistoryPage /></GuardedRoute>
            {/* Puna personale nuk kërkon leje moduli: ajo i takon vetë personit. */}
            <Route path="/my-tasks"><MyTasksPage /></Route>
            <Route path="/my-onboarding"><MyOnboardingPage /></Route>
            <GuardedRoute path="/onboarding/:id"><OnboardingDetailPage /></GuardedRoute>
            <GuardedRoute path="/onboarding"><OnboardingPage /></GuardedRoute>
            <GuardedRoute path="/payroll-adjustments"><PayrollAdjustmentsPage /></GuardedRoute>
            <GuardedRoute path="/my-adjustments"><MyAdjustmentsPage /></GuardedRoute>
            {/* Rrugët e vjetra mbeten të gjalla: një faqerojtës ose lidhje e
                ruajtur nuk duhet të përfundojë në ekran bosh. Ridrejtohen te
                tabi përkatës i faqes së re. */}
            <Redirect from="/bonuses"         to="/payroll-adjustments" />
            <Redirect from="/salary-advances" to="/payroll-adjustments" />
            <Redirect from="/reimbursements"  to="/payroll-adjustments" />
            <GuardedRoute path="/procedures"><ProceduresPage /></GuardedRoute>
            <GuardedRoute path="/leave-adjustments"><LeaveAdjustmentsPage /></GuardedRoute>
            <GuardedRoute path="/communication"><CommunicationPage /></GuardedRoute>
            <GuardedRoute path="/leave-policies"><LeavePoliciesPage /></GuardedRoute>
            <GuardedRoute path="/policies"><PoliciesPage /></GuardedRoute>
            <GuardedRoute path="/regulations"><RegulationsPage /></GuardedRoute>
            <GuardedRoute path="/knowledge-base"><KnowledgeBasePage /></GuardedRoute>
            <GuardedRoute path="/notifications-center"><NotificationsCenterPage /></GuardedRoute>
            <GuardedRoute path="/monitoring"><AuditLog /></GuardedRoute>
            <GuardedRoute path="/applications/add"><ApplicationForm /></GuardedRoute>
            <GuardedRoute path="/applications/edit/:id"><ApplicationForm /></GuardedRoute>
            <GuardedRoute path="/applications"><ApplicationsList /></GuardedRoute>
            <GuardedRoute path="/job-postings"><JobPostingsList /></GuardedRoute>
            <GuardedRoute path="/recruitment"><RecruitmentOverview /></GuardedRoute>
            <GuardedRoute path="/warnings/add"><AddWarning /></GuardedRoute>
            <GuardedRoute path="/warnings"><WarningsReport /></GuardedRoute>
            {/* Rendi ka rëndësi: `<Switch>` ndalet te përputhja e parë dhe
                `/assets` nuk është `exact`, ndaj do t'i kapte të gjitha nën-rrugët. */}
            <GuardedRoute path="/assets/handover/:id"><AssetHandoverPage /></GuardedRoute>
            <GuardedRoute path="/assets/new"><AssetFormPage /></GuardedRoute>
            <GuardedRoute path="/assets/:id/edit"><AssetFormPage /></GuardedRoute>
            <GuardedRoute path="/assets/:id"><AssetDetailPage /></GuardedRoute>
            <GuardedRoute path="/assets"><AssetsRegister /></GuardedRoute>
            <GuardedRoute path="/my-assets"><MyAssetsPage /></GuardedRoute>
            <GuardedRoute path="/leave-calendar"><HolidayCalendarPage /></GuardedRoute>
            {/* Pa zë te sidebar-i, ROUTE_PERMISSIONS s'ka nga ku ta derivojë
                mbrojtjen — prandaj deklarohet këtu, njësoj si më parë. */}
            <GuardedRoute
              path="/templates"
              requiresAny={[P.SETTINGS_VIEW, P.SETTINGS_MANAGE, P.CONTRACTS_CREATE, P.WARNINGS_CREATE]}
            >
              <TemplatesPage />
            </GuardedRoute>
            <GuardedRoute path="/compliance"><CompliancePage /></GuardedRoute>
            <GuardedRoute path="/audit-log"><AuditLog /></GuardedRoute>
            {/* /holidays/* survives the retirement of the "Kërkesat për pushim"
                module: addholiday IS the active submission form (linked from
                /inbox, /my-leaves, EmployeeHome and the "Kërko Leje" sidebar
                entry) and AddHoliday redirects into editholiday after saving.

                requiresAny is now explicit. These sub-routes used to inherit
                their permissions from the /holidays sidebar entry via
                getRouteRequirements' longest-prefix match; with that entry gone
                the lookup finds nothing and GuardedRoute falls back to an
                UNGUARDED plain Route. Spelling out what /holidays granted keeps
                the protection identical. */}
            <GuardedRoute path="/holidays/addholiday"><AddHoliday /></GuardedRoute>
            <GuardedRoute path="/holidays/editholiday/:id"
              requiresAny={['leave.view.department', 'leave.view.company', 'leave.manage']}>
              <EditHoliday />
            </GuardedRoute>
            {/* Must precede the non-exact /holidays below — inside a Switch that
                would otherwise match /holidays/calendar first. */}
            <GuardedRoute path="/holidays/calendar"
              requiresAny={['leave.view.department', 'leave.view.company', 'leave.manage']}>
              <LeaveCalendar />
            </GuardedRoute>
            {/* Retired module → the Approval Center, which lists and approves
                leave requests from the same GET /api/holidays feed. */}
            <GuardedRoute path="/holidays"><Redirect to="/inbox" /></GuardedRoute>
            <GuardedRoute path="/my-leaves"><MyLeavesPage /></GuardedRoute>
            <GuardedRoute path="/my-leave-report"><MyLeaveReportPage /></GuardedRoute>
            <GuardedRoute path="/my-payslips/stats/:year"><MyPayslipStatsPage /></GuardedRoute>
            <GuardedRoute path="/my-payslips/:year/:month"><MyPayslipDetailPage /></GuardedRoute>
            <GuardedRoute path="/my-payslips"><MyPayslipsPage /></GuardedRoute>
            {/* Retired module → the Approval Center approves leave inline through
                the same two-stage /api/holidays/:id/{supervisor,hr}-decision API. */}
            <GuardedRoute path="/leave-approvals"><Redirect to="/inbox" /></GuardedRoute>
            {/* Konsoliduar në hub-in e vetëm /user-management (tabet Rolet & Pozitat).
                Rrugët e vjetra ridrejtohen te tab-i i saktë që lidhjet s'prishen. */}
            <GuardedRoute path="/roles-permissions"><Redirect to="/user-management?tab=1" /></GuardedRoute>
            <GuardedRoute path="/positions"><Redirect to="/user-management?tab=2" /></GuardedRoute>
            <GuardedRoute path="/user-management"><UserManagementPage /></GuardedRoute>
            <GuardedRoute path="/documents"><DocumentsPage /></GuardedRoute>
            <GuardedRoute path="/company"><Company /></GuardedRoute>
            {/* «Konfigurim» te shiriti anësor është /company; kjo faqe mban
                rregullat që s'janë të kompanisë por të punës — mes tyre fjalorin
                e llojeve. Ishte e importuar dhe kurrë e renderuar: tab-i «Llojet
                e punës» ekzistonte pa asnjë rrugë që të çonte te ai. */}
            {/* Konfigurimi është NJË faqe: /company. Kjo rrugë mbeti pa hyrje te
                menyja dhe askush s'i gjente dot llojet e punës; tani ridrejton
                te tab-i përkatës i hub-it. */}
            <GuardedRoute path="/work-types"><Redirect to="/company?tab=llojet-punes" /></GuardedRoute>
            <GuardedRoute path="/settings"><Redirect to="/company" /></GuardedRoute>
            <GuardedRoute path="/profile"><UserProfile /></GuardedRoute>
            <GuardedRoute path="/module-management"><ModuleManagementPage /></GuardedRoute>
            <GuardedRoute path="/m/:moduleKey/:recordId/:action" component={DynamicModulePage} />
            <GuardedRoute path="/m/:moduleKey/:recordId" component={DynamicModulePage} />
            <GuardedRoute path="/m/:moduleKey" component={DynamicModulePage} />
          </Switch>
        )}
      </Box>

      {/* ── Bottom Navigation — Mobile only ── */}
      {isMobile && (
        <Paper
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: theme.zIndex.appBar,
            borderTop: `1px solid ${theme.palette.divider}`,
            boxShadow: '0 -2px 12px rgba(0,0,0,0.08)',
          }}
          elevation={0}
        >
          <BottomNavigation
            value={bottomNavValue >= 0 ? bottomNavValue : false}
            sx={{ height: 60, bgcolor: 'background.paper' }}
          >
            {bottomNavItems.map((item, idx) => (
              <BottomNavigationAction
                key={item.to || 'menu'}
                label={item.label}
                icon={item.icon}
                component={item.to ? Link : 'button'}
                to={item.to || undefined}
                onClick={item.to ? handleCloseMobile : handleToggleMobile}
                sx={{
                  minWidth: 0,
                  px: 0.5,
                  '& .MuiBottomNavigationAction-label': {
                    fontSize: '0.62rem',
                    fontWeight: 600,
                    mt: 0.25,
                    opacity: 1,
                  },
                  '&.Mui-selected': {
                    color: 'primary.main',
                  },
                  color: bottomNavValue === idx ? 'primary.main' : 'text.secondary',
                }}
              />
            ))}
          </BottomNavigation>
        </Paper>
      )}

      <ChangePassword
        open={changePasswordOpen}
        onClose={() => setChangePasswordOpen(false)}
        userId={currentUser?.data?.id}
      />

      <Dialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', pt: 3.5, pb: 1 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'rgba(220, 38, 38, 0.10)',
              color: '#DC2626',
            }}
          >
            <LogoutIcon sx={{ fontSize: 28 }} />
          </Box>
        </Box>
        <DialogTitle
          sx={{
            textAlign: 'center',
            fontWeight: 700,
            fontSize: '1.05rem',
            color: '#0F172A',
            pt: 1.5,
            pb: 0.5,
          }}
        >
          {t('menu.confirmLogout')}
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center', pb: 2 }}>
          <Typography variant="body2" sx={{ color: '#475569', lineHeight: 1.55 }}>
            {t('menu.confirmLogoutMsg')}
          </Typography>
          <Box
            sx={{
              mt: 2.25,
              mx: 'auto',
              px: 2,
              py: 1.25,
              maxWidth: 320,
              borderRadius: 2,
              bgcolor: '#F8FAFC',
              border: '1px solid #EEF2F6',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1.25,
              textAlign: 'left',
            }}
          >
            <Typography sx={{ fontSize: '1.25rem', lineHeight: 1, flexShrink: 0 }}>👋</Typography>
            <Typography sx={{ fontSize: '0.78rem', color: '#64748B', lineHeight: 1.45 }}>
              {t('menu.logoutFarewell')}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5, pt: 0.5, gap: 1 }}>
          <Button
            fullWidth
            onClick={() => setLogoutDialogOpen(false)}
            variant="outlined"
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2,
              py: 1,
              color: '#475569',
              borderColor: '#E2E8F0',
              '&:hover': { borderColor: '#CBD5E1', bgcolor: '#F8FAFC' },
            }}
          >
            {t('menu.cancel')}
          </Button>
          <Button
            fullWidth
            onClick={() => loginService().logout()}
            variant="contained"
            startIcon={<LogoutIcon sx={{ fontSize: 18 }} />}
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              borderRadius: 2,
              py: 1,
              bgcolor: '#DC2626',
              boxShadow: 'none',
              '&:hover': { bgcolor: '#B91C1C', boxShadow: 'none' },
            }}
          >
            {t('menu.yesLogout')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* PWA Install Banner — shfaqet automatikisht kur mund të instalohet */}
      <PWAInstallBanner />

      {/* Offline indicator */}
      <OfflineBar />

      {/* Updates / Changelog modal */}
      <UpdatesModal
        open={updatesOpen}
        onClose={() => { setUpdatesOpen(false); setUpdatesUnseen(false); }}
        userId={_userId}
      />

    </Box>
  );
}

// ── Page title helper ─────────────────────────────────────────────────────────
// Maps the current raw title (Albanian fallback from getTitle) to a translation
// key derived from the first meaningful path segment.
function pathToTitleKey(pathname) {
  if (pathname === '/' || pathname === '/home') return 'home';
  if (pathname.startsWith('/home/reports/work-schedule-matrix')) return 'schedule-matrix';
  if (pathname.startsWith('/home/reports/attendance-schedule'))  return 'attendance-schedule';
  if (pathname.startsWith('/home/reports/schedule-compliance-summary')) return 'schedule-compliance';
  if (pathname.startsWith('/home/reports/attendance-rate')) return 'attendance-rate';
  if (pathname.startsWith('/home/reports/work-hours')) return 'work-hours';
  if (pathname.startsWith('/home/reports')) return 'reports';
  if (pathname.startsWith('/tasks/dashboard')) return 'tasks_dashboard';
  if (pathname.startsWith('/tasks/board'))     return 'tasks_board';
  if (pathname.startsWith('/oret'))            return 'oret';
  if (pathname.startsWith('/fte-plan'))        return 'fte-plan';
  // Worker sub-routes — show a more specific title than the generic "Punëtorët"
  if (pathname.startsWith('/workerlist/worker/'))     return 'worker-profile';
  if (pathname.startsWith('/workerlist/editworker/')) return 'worker-edit';
  if (pathname.startsWith('/workerlist/register'))    return 'worker-register';
  if (pathname.startsWith('/workerlist/addworker'))   return 'worker-add';
  // Use first path segment for all remaining routes
  const seg = pathname.split('/').filter(Boolean)[0];
  return seg || 'home';
}

function tPageTitle(pathname, navItems, t) {
  const rawTitle = getTitle(pathname, navItems);
  const key = pathToTitleKey(pathname);
  return t(`pageTitle.${key}`, rawTitle);
}

function getTitle(pathname, navItems) {
  if (pathname === '/' || pathname === '/home') return 'Home';
  // Worker sub-routes — check BEFORE the navItems loop so they don't fall back to "Punëtorët"
  if (pathname.startsWith('/workerlist/worker/'))     return 'Profili i punëtorit';
  if (pathname.startsWith('/workerlist/editworker/')) return 'Ndrysho punëtor';
  // Një formë, një emër: butoni te lista thotë «Shto Punëtor», ndaj edhe koka.
  if (pathname.startsWith('/workerlist/register'))    return 'Shto punëtor';
  if (pathname.startsWith('/workerlist/addworker'))   return 'Shto punëtor';
  // Përputhje te kufiri i segmentit, jo prefiks i thatë: `/performance-setup`
  // nis me `/performance`, ndaj koka e faqes tregonte titullin e tabelës së
  // performancës — dhe çdo rrugë e re me të njëjtin prefiks do ta bënte njësoj.
  const match = navItems.find((n) => n.to && (pathname === n.to || pathname.startsWith(`${n.to}/`)));
  if (match) return match.label;
  if (pathname.startsWith('/workerlist'))    return 'Punëtorët';
  if (pathname.startsWith('/contractlist'))  return 'Kontratat';
  if (pathname.startsWith('/salarieslist'))  return 'Pagat';
  if (pathname.startsWith('/leave-calendar')) return 'Kalendari';
  if (pathname.startsWith('/home/reports/work-schedule-matrix')) return 'Orari Mujor Individual';
  if (pathname.startsWith('/home/reports/attendance-schedule')) return 'Raporti Attendance';
  if (pathname.startsWith('/home/reports/schedule-compliance-summary')) return 'Raporti i Orarit';
  if (pathname.startsWith('/home/reports/attendance-rate')) return 'Attendance Rate';
  if (pathname.startsWith('/home/reports/work-hours')) return 'Raporti i Orëve të Punës';
  if (pathname.startsWith('/home/reports'))  return 'Raporte';
  if (pathname.startsWith('/warnings'))      return 'Vërejtjet';
  if (pathname.startsWith('/my-assets'))     return 'Asetet e mia';
  if (pathname.startsWith('/assets'))        return 'Asetet';
  if (pathname.startsWith('/compliance'))    return 'Compliance';
  if (pathname.startsWith('/audit-log'))     return 'Audit Log';
  if (pathname.startsWith('/holidays'))      return 'Pushimet';   // /holidays/addholiday|editholiday|calendar
  if (pathname.startsWith('/settings'))      return 'Kompania & Konfigurim';
  if (pathname.startsWith('/company'))       return 'Kompania';
  if (pathname.startsWith('/job-postings'))   return 'Pozitat';
  if (pathname.startsWith('/work-schedules'))  return 'Schedule';
  if (pathname.startsWith('/inbox'))          return 'Kërkesat dhe Aprovimet';
  if (pathname.startsWith('/attendance-corrections')) return 'Korrigjime Prezence';
  if (pathname.startsWith('/attendance'))       return 'Paneli Attendance';
  if (pathname.startsWith('/my-attendance'))    return 'Prezenca ime';
  if (pathname.startsWith('/time-tracking'))       return 'Time Tracking';
  if (pathname.startsWith('/documents'))            return 'Dokumentet';
  if (pathname.startsWith('/my-leave-report'))       return 'Raporti i pushimeve';
  if (pathname.startsWith('/my-leaves'))             return 'Pushimet e mia';
  if (pathname.startsWith('/my-payslips'))            return 'Pagat e mia';
  if (pathname.startsWith('/my-evaluation'))        return 'Vlerësimi im';
  // Fillimi me prefiks kapte edhe `/performance-setup`, dhe koka lexonte
  // «Performance» mbi një faqe që quhet «Konfigurimi i vlerësimit». Rruga më e
  // gjatë shkruhet e para, siç bëhet kudo tjetër te kjo listë.
  if (pathname.startsWith('/offers'))               return 'Ofertat';
  if (pathname.startsWith('/performance-setup')) return 'Konfigurimi i vlerësimit';
  if (pathname.startsWith('/performance'))          return 'Tabela e performancës';
  if (pathname.startsWith('/shift-templates'))      return 'Modelet e Turneve';
  if (pathname.startsWith('/interviews'))           return 'Intervistat';
  if (pathname.startsWith('/onboarding'))           return 'Onboarding';
  // Jashtë menyje, por të arritshme me URL — koka nuk duhet të bjerë te «Nexuma».
  if (pathname.startsWith('/my-onboarding'))        return 'Onboarding im';
  if (pathname.startsWith('/my-tasks'))             return 'Detyrat e mia';
  if (pathname.startsWith('/payroll-adjustments'))  return 'Rregullimet e pagës';
  if (pathname.startsWith('/my-adjustments'))       return 'Rregullimet e mia';
  if (pathname.startsWith('/procedures'))           return 'Procedurat';
  if (pathname.startsWith('/policies'))             return 'Politikat';
  if (pathname.startsWith('/regulations'))          return 'Rregulloret';
  if (pathname.startsWith('/knowledge-base'))       return 'Qendra e Njohurive';
  if (pathname.startsWith('/notifications-center')) return 'Njoftimet';
  if (pathname.startsWith('/monitoring'))           return 'Monitoring';
  return 'Nexuma';
}

function getCompanyLabel(user) {
  if (!user) return config?.company || '';
  return user?.company || user?.Company || user?.data?.company || user?.data?.Company || user?.data?.db || config?.company || '';
}
